import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { BaseComponent } from '@uw/core/base.component';
import { Alert } from '@uw/core/models/alert.model';

import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ChangePasswordFormData } from '../../modals/change-password-form-data';
import { PasswordRegistrationComponent } from '@uw/shared/components/password-registration/password-registration.component';
import { NgStyle } from '@angular/common';
import { PasswordComponent } from '../../../../shared/components/password/password.component';
import { MatError } from '@angular/material/input';
import { PasswordRegistrationComponent as PasswordRegistrationComponent_1 } from '../../../../shared/components/password-registration/password-registration.component';
import { UwButtonComponent } from '../../../../shared/components/button/button.component';

@Component({
    selector: 'app-change-password-form',
    templateUrl: './change-password-form.component.html',
    styleUrls: ['./change-password-form.component.scss'],
    imports: [ReactiveFormsModule, NgStyle, PasswordComponent, MatError, PasswordRegistrationComponent_1, UwButtonComponent, TranslateModule]
})
export class ChangePasswordFormComponent
  extends BaseComponent
  implements OnInit
{
  @Input()
  buttonLoading: boolean = false;

  @Input()
  actionButtonLabel: string = 'buttons.update';

  @Output()
  changePassword = new EventEmitter<ChangePasswordFormData>();

  @ViewChild(PasswordRegistrationComponent)
  passwordRegistrationFormComponent!: PasswordRegistrationComponent;

  changePasswordFormGrp!: UntypedFormGroup;

  alerts: Alert[] = [];
  passwordRequirementMessage!: string;

  readonly currentLanguage = this.translateService.currentLang;

  constructor(
    private fb: UntypedFormBuilder,
    public translateService: TranslateService
  ) {
    super();
    this.createForm();
  }

  createForm() {
    this.changePasswordFormGrp = this.fb.group(
      {
        currentPassword: [null, [Validators.required]],
        passwordRegistration: this.fb.control(null),
      }
    );
  }

  onChangePassword(): void {
    this.markAllAsTouched(this.changePasswordFormGrp);
    if (this.changePasswordFormGrp.valid) {
      const { currentPassword, passwordRegistration } =
        this.changePasswordFormGrp.value;

      const { password: newPassword, confirmPassword } = passwordRegistration;

      const payload = { currentPassword, newPassword, confirmPassword };

      this.changePassword.emit(payload);
    }
  }

  private markAllAsTouched(formGroup: FormGroup<any>) {
    formGroup.markAllAsTouched();

    // Explicitly mark child form controls as touched
    if (this.passwordRegistrationFormComponent) {
      this.passwordRegistrationFormComponent.markAllControlsAsTouched();
    }
  }

}
